module.exports = __webpack_public_path__ + "img/CRM_swiperTab_img1.08cb7afb.png";